import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, Title } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ConfirmationService, MessageService, TreeDragDropService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from './environments/environment';
import { httpInterceptorProviders } from './app/http-interceptors';
import { AppPreset } from './app/theme/app-preset';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: { preset: AppPreset, options: { darkModeSelector: false, cssLayer: false } },
    }),
    importProvidersFrom(
      TranslateModule.forRoot({ loader: { provide: TranslateLoader, useClass: TranslateHttpLoader } }),
    ),
    provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    Title,
    NgxSpinnerService,
    ConfirmationService,
    TreeDragDropService,
    MessageService,
    httpInterceptorProviders,
  ],
}).catch((err) => console.error(err));
